import React from "react";
import { Trans } from "react-i18next";

import { FormGroup, InputGroup, Tag } from "@blueprintjs/core";

import { getCurrencySymbol } from "./mef";

export default class PriceInput extends React.Component {
  constructor(props) {
    let defaultValue = props.defaultValue || 0;
    super(props);
    this.state = {
      strValue: "" + defaultValue,
      amountValue: defaultValue,
      amountValueCents: defaultValue * 100,
      min: this.props.min || 0,
      max: this.props.max || 10000,
    };
  }

  render() {
    return (
      <FormGroup
        label={<Trans>{this.props.label}</Trans>}
        labelFor="pricei"
        inline={true}
      >
        <InputGroup
          value={this.state.strValue}
          id="pricei"
          rightElement={<Tag>{getCurrencySymbol()}</Tag>}
          onValueChange={(str) => {
            str=str.replace(",", ".").replace("-", "").replace("e", "")
            let num = parseFloat(str);

            // fix if > max
            if (num > this.state.max) {
              num = this.state.max;
              str = "" + this.state.max;
            }

            // fix if < min
            if (num < this.state.min) {
              num = this.state.min;
              str = "" + this.state.min;
            }

            // limit precision in string display
            if (!isNaN(str + "0")) {
              const splitted = str.split(".");
              if (splitted.length !== 2) this.setState({ strValue: str });
              else
                this.setState({
                  strValue: splitted[0] + "." + splitted[1].slice(0, 2),
                });
            }

            // update if valid
            if (!isNaN(num))
              this.setState(
                {
                  amountValue: num.toFixed(2),
                  amountValueCents: num.toFixed(2) * 100,
                },
                () => {
                  if (this.props.onValueChange)
                    this.props.onValueChange(this.state.amountValueCents);
                }
              );
          }}
        />
      </FormGroup>
    );
  }
}
